'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';

// Définition du module de base pour autorisations d'exploitation
const MODULE_NAME = 'observatoireApp.autorisationsExploitation';

// Création du module sans configuration de routes (les routes sont définies dans autorisations-exploitation.routes.js)
angular.module(MODULE_NAME, [uiRouter]);

export default MODULE_NAME;
